
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.655 6.345a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 01-1.06 0l-3-3a.75.75 0 011.06-1.06l2.47 2.47 4.72-4.72a.75.75 0 011.06 0z","fill":"#fff"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      